import SettingIcon from '@mui/icons-material/Settings';
import ApiIcon from '@mui/icons-material/Api';
import CalculateIcon from '@mui/icons-material/Calculate';
import HelpersIcon from '@mui/icons-material/Help';
import SeoIcon from '@mui/icons-material/SavedSearch';
import TagIcon from '@mui/icons-material/Tag';
import CityIcon from '@mui/icons-material/LocationCity';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import EmailIcon from '@mui/icons-material/Email';

import SettingsList from './SettingsList';
import GeneralForm from './GeneralForm';
import LogixForm from './LogixForm';
import CalculatorForm from './CalculatorForm';
import HelpersForm from './HelpersForm';
import SeoForm from './SeoForm';
import ShortcodesForm from './ShortcodesForm';
import CitiesForm from './CitiesForm';
import DynamicPagesForm from './DynamicPagesForm';
import EmailsForm from './EmailsForm';

import calculation_insurance_prices from './calculation_insurance_prices';
import orders_filter_status_sets from './orders_filter_status_sets';

const resource = {
    icon: SettingIcon,
    list: SettingsList,
    general: {
        icon: SettingIcon,
        form: GeneralForm,
    },
    logix: {
        icon: ApiIcon,
        form: LogixForm,
    },
    calculator: {
        icon: CalculateIcon,
        form: CalculatorForm,
    },
    helpers: {
        icon: HelpersIcon,
        form: HelpersForm,
    },
    seo: {
        icon: SeoIcon,
        form: SeoForm,
    },
    shortcodes: {
        icon: TagIcon,
        form: ShortcodesForm,
    },
    cities: {
        icon: CityIcon,
        form: CitiesForm,
    },
    dynamic_pages: {
        icon: AutoStoriesIcon,
        form: DynamicPagesForm,
    },
    emails: {
        icon: EmailIcon,
        form: EmailsForm,
    },
    calculation_insurance_prices,
    orders_filter_status_sets,
};

export default resource;
